'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  children: _react.PropTypes.node.isRequired,
  right: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  cssModule: _react.PropTypes.object
};

var contextTypes = {
  isOpen: _react.PropTypes.bool.isRequired
};

var DropdownMenu = function DropdownMenu(props, context) {
  var className = props.className;
  var cssModule = props.cssModule;
  var right = props.right;

  var attributes = _objectWithoutProperties(props, ['className', 'cssModule', 'right']);

  var classes = (0, _utils.mapToCssModules)((0, _classnames2.default)(className, 'dropdown-menu', { 'dropdown-menu-right': right }), cssModule);

  return _react2.default.createElement('div', _extends({}, attributes, { tabIndex: '-1', 'aria-hidden': !context.isOpen, role: 'menu', className: classes }));
};

DropdownMenu.propTypes = propTypes;
DropdownMenu.contextTypes = contextTypes;

exports.default = DropdownMenu;


//////////////////
// WEBPACK FOOTER
// ./~/reactstrap/lib/DropdownMenu.js
// module id = 1499
// module chunks = 0